import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

const onRedirectCallback = (appState) => {
  const target = appState?.returnTo || '/dashboard';
  // Use replace to avoid polluting history, default to dashboard
  window.location.replace(target);
};

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    cacheLocation="localstorage"
    useRefreshTokens
    useRefreshTokensFallback
    // Callback lands on /dashboard to match Auth0 allowed URLs
    authorizationParams={{
      redirect_uri: `${window.location.origin}/dashboard`,
      scope: 'openid profile email'
    }}
    onRedirectCallback={onRedirectCallback}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Auth0Provider>
);